import type { ApiResponse } from '~~/app/types/shared/ApiResponse'
import type { KontentPageRoute } from '~~/app/types/shared/KontentPageRoute'

export function usePageUrls() {
  const getUrlByCodename = async (codename: string): Promise<string> => {
    const response = await $fetch<ApiResponse<KontentPageRoute>>(
      `/api/page/info?codename=${codename}`
    )
    if (response.data) {
      return response.data.path || ''
    }
    return ''
  }

  const getUrlByItemId = async (itemId: string) => {
    const response = await $fetch<ApiResponse<KontentPageRoute>>(`/api/page/info?itemid=${itemId}`)
    if (response.data) {
      return response.data.path || ''
    }
    return ''
  }

  return {
    getUrlByCodename,
    getUrlByItemId
  }
}
